import { BOOKING_REQUEST, BOOKING_SUCCESS, BOOKING_FAILURE, BOOKING_EDIT_PAGE_REQUEST, BOOKING_EDIT_PAGE_SUCCESS, BOOKING_DELETE_CONFIRM, BOOKING_DELETE_CONFIRM_DECLINE, BOOKING_DELETE_REQUEST, BOOKING_DELETE_FAILURE, BOOKING_DELETE_SUCCESS, BOOKING_CREATE_REQUEST, BOOKING_PROJECT_OPTIONS_REQUEST, BOOKING_PROJECT_OPTIONS_FAILURE, BOOKING_PROJECT_OPTIONS_SUCCESS, BOOKING_PROJECT_UNIT_OPTIONS_FAILURE, BOOKING_PROJECT_UNIT_OPTIONS_REQUEST, SET_PROJECT_UNIT_OPTIONS, BOOKING_CREATE_OR_UPDATE_PAGE_REQUEST } from "../../redux/action_constant";
import { ProjectInterface } from "../Projects/ProjectTypes";
import { ProjectUnitInterface } from "../ProjectsUnit/ProjectUnitTypes";

export interface BookingInterface {
    id: string;
    uuid: string;
    book_id: string;
    user_id: string;
    project_id: string;
    project: ProjectInterface;
    project_unit_id: number[];
    project_unit: ProjectUnitInterface[] | ProjectUnitOptionInterface[] | any;
    customer_name: string;
    rate_per_square_feet: number;
    total_cost: number;
    sub_total: number;
    discount: number;
    tax_amount: number;
    tax_percentage: number;
    tax_name: string;
    created_at: Date;
    updated_at: Date;
    total_paid: number;
    customer_phone: number;
    area: number;
    length: number;
    width: number;
    payment_schedule: any[];
    agent_id: string;
    isRegistry: boolean;
    is_resale: boolean;
    project_units: any;
    otp: number;
    type: BookingInterfaceStatus;
    cost_key: number | any;
    rate_key: number | any;
    receipts: any[];
    rateValue: number;
    paid_amount: number;
    guideline_rate: number;
    intrest_on_late_payment?: number;
    booking_form_name?: string;
    status: "ACTIVE" | "CANCELLED" | "COMPLETED";
    amount_return_to_customer: number;
    is_session?: boolean;
    is_registration_complete?: boolean;
    is_payment_received?: boolean;
    agent_bookings: {
        project_id: number;
        booking_id: number;
        agent_id: number;
        commission: number;
        error?: boolean;
    }[];
}

export interface createOrUpdateBookingInterface {
    data: BookingInterface;
    file: any;
    isEdit: boolean;
};

export enum BookingInterfaceStatus {
    CREATE_BOOKING = 'CREATE_BOOKING',
    UPDATE_BOOKING = 'UPDATE_BOOKING',
    CANCEL_BOOKING = 'CANCEL_BOOKING'
};

export interface ProjectOptionInterface extends ProjectInterface {
    value: string;
    label: string;
}

export interface ProjectUnitOptionInterface extends ProjectUnitInterface {
    value: number;
    label: string;
}

export interface BookingState {
    pending: boolean;
    error: any;
    loading: boolean;
    bookingList: BookingInterface[];
    next_offset: Number;
    listCount: Number;
    editBooking: BookingInterface;
    showDeleteModal: boolean;
    deleteBooking: BookingInterface;
    projectOptions: ProjectOptionInterface[];
    projectUnitOptions: ProjectUnitOptionInterface[];
    totalBookedArea: number;
    totalBookingValue: number;
    totalRecivedAmount: number;
};

export interface bookingAddOrEditRequestPayload {
    data: BookingInterface | ProjectUnitInterface;
    isEdit: boolean;
}

export interface BookingRequestPayload {
    page: Number;
    keyword?: string;
    fromDate?: Date;
    toDate?: Date;
    limit?: Number;
    project?: string;
    is_session?: boolean;
};

export type BookingRequest = {
    type: typeof BOOKING_REQUEST;
    payload: BookingRequestPayload;
};

export interface BookingRequestSuccessPayload {
    list: BookingInterface[] | ProjectOptionInterface[];
    next_offset: Number;
    count: Number;
};

export type BookingRequestSuccess = {
    type: typeof BOOKING_SUCCESS;
    payload: any;
};

export type BookingRequestFailure = {
    type: typeof BOOKING_SUCCESS | typeof BOOKING_FAILURE | typeof BOOKING_DELETE_CONFIRM_DECLINE | typeof BOOKING_DELETE_REQUEST | typeof BOOKING_DELETE_FAILURE | typeof BOOKING_DELETE_SUCCESS | typeof BOOKING_PROJECT_OPTIONS_REQUEST | typeof BOOKING_PROJECT_OPTIONS_FAILURE | typeof BOOKING_PROJECT_UNIT_OPTIONS_REQUEST | typeof BOOKING_PROJECT_UNIT_OPTIONS_FAILURE;
    payload: string;
};

export type BookingEditPageRequest = {
    type: typeof BOOKING_EDIT_PAGE_REQUEST | typeof BOOKING_EDIT_PAGE_SUCCESS | typeof BOOKING_DELETE_CONFIRM | typeof BOOKING_CREATE_REQUEST | typeof BOOKING_CREATE_OR_UPDATE_PAGE_REQUEST;
    payload: bookingAddOrEditRequestPayload;
};

export type BookingCreateRequest = {
    type: typeof BOOKING_CREATE_REQUEST;
    payload: createOrUpdateBookingInterface;
};


export type projectOptionsSuccess = {
    type: typeof BOOKING_PROJECT_OPTIONS_SUCCESS;
    payload: BookingRequestSuccessPayload;
};

export type updateProjectUnitOptionsRequest = {
    type: typeof SET_PROJECT_UNIT_OPTIONS;
    payload: ProjectUnitOptionInterface[];
}


export type ProjectActions = BookingRequest | BookingRequestSuccess | BookingRequestFailure | BookingEditPageRequest | projectOptionsSuccess | updateProjectUnitOptionsRequest | BookingCreateRequest;